import classNames from "classnames";
import { FC } from "react";
import SvgCheck from "../icons/CheckCircle";
import styles from "./BlueCheck.module.css";
type BlueCheckProps = {
  className?: string;
};

const BlueCheck: FC<BlueCheckProps> = ({ className }) => {
  return <SvgCheck className={classNames(styles.check, className)} />;
};

export default BlueCheck;
